import './App.css';
import Navbar from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { HairDressersSection } from './components/HairDressersSection';
import { GallerySection } from './components/GallerySection';
import TestimonySection from './components/TestimonySection';
import Footer from './components/Footer';
import { FaArrowUp } from 'react-icons/fa';
import { useEffect, useState } from 'react';


function App() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const pageHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollPercentage = (scrollPosition / pageHeight) * 100;

      if (scrollPercentage > 10) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Scroll to top handler
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <Navbar />
      <HeroSection/>
      <ServicesSection />
      <HairDressersSection />
      <GallerySection />
      <TestimonySection />
      <Footer />
      {showScrollButton && (
        <button
          onClick={scrollToTop}
          style={{
            color: 'white',
            backgroundColor: '#bf925b',
            borderRadius: '100%',
            width: '50px',
            height: '50px',
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: '1000',
          }}
          className="btn-floating btn-lg"
          id="btn-back-to-top"
        >
          <FaArrowUp style={{ width: '100%' }} />
        </button>
      )}
    </> 
  );
}

export default App;
